import React, { useMemo } from 'react'
import { Box, Link, Pill } from '@maui/elements'
import { ArticlesWidget } from '@nautilusjs/component-core'
import { Timestamp } from './Timestamp'
import { WidgetLoading } from './WidgetLoading'
import { UpgradeIconPill } from '@maui/freemium'
import { useHasAccessToObject } from '../../useHasAccessToObject'

export const RelevantReportingWidgetItem = ({ report }) => {
  const hasAccessToObject = useHasAccessToObject()
  const locked = !hasAccessToObject(report)
  const url = report.url || `/reports/${report.id}`

  return (
    <Box
      borderBottomColor="colorBorderMain"
      borderBottomStyle="solid"
      borderBottomWidth="1px"
      padding="12px 0"
      _first={{
        paddingTop: '8px'
      }}
    >
      <Box
        display="flex"
        marginBottom="spaceGapSmall"
      >
        { locked &&
          <UpgradeIconPill iconSize='sm' variant='icon' mr='spaceGapSmall' mb='spaceGapMedium' />
        }
        <Link
          as='a'
          href={url}
          overflow='hidden'
          textOverflow='ellipsis'
          whiteSpace='nowrap'
          fontSize='textBodySmallFontSize'
          fontWeight='fontWeightBold'
          color='colorTextMain'
          lineHeight='textAvatarLineHeight'
          marginBottom='5px'
          title={report.name}
        >
          {report.name}
        </Link>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        {report.reportType && (
          <Pill variant="dim" style={{ marginLeft: '0' }} role="pill">
            {report.reportType}
          </Pill>
        )}
        <Timestamp
          format={'distance'}
          value={(report.date || report.created)}
          fontWeight='fontWeightBold'
          fontSize='textAvatarFontSize'
          lineHeight='textAvatarLineHeight'
          color='colorTextDeemphasis'
        />
      </Box>
    </Box>
  )
}

export const RelevantReportingWidget = ({ className, reports, header, ...widgetProps }) => {
  const content = useMemo(() => {
    if (reports === undefined) {
      return <WidgetLoading />
    }

    const filteredReports = reports?.filter(report => report.url || report.report_id)

    if (reports === null || !filteredReports?.length) {
      return <Box padding="12px 0">No reports available</Box>
    }

    return filteredReports.map((report, i) =>
      <RelevantReportingWidgetItem key={i} report={report} />
    )
  }, [reports])

  return (
    <ArticlesWidget
      autoHeight={false}
      className={className}
      header={header || 'Relevant Reporting'}
      scrollable={reports !== undefined}
      {...widgetProps}
    >
      {content}
    </ArticlesWidget>
  )
}

export default RelevantReportingWidget
